<template>
  <div>
    <template v-if="pathName === 'district'">
      <CRow class="mb-2">
        <CCol col="3" class="align-self-center">Cấp Tỉnh</CCol>
        <CCol col="9">
          <vue-multiselect v-model="filter.provinceSelected" :options="provinceList"
                           placeholder="-- Chọn cấp Tỉnh" label="name" track-by="id"
                           :multiple="true" :taggable="true"></vue-multiselect>
        </CCol>
      </CRow>

      <hr/>
    </template>

    <template v-if="pathName === 'commune'">
      <CRow class="mb-2">
        <CCol col="3" class="align-self-center">Cấp Huyện</CCol>
        <CCol col="9">
          <vue-multiselect v-model="filter.districtSelected" :options="districtList"
                           placeholder="-- Chọn cấp Huyện" label="name" track-by="id"
                           :multiple="true" :taggable="true"></vue-multiselect>
        </CCol>
      </CRow>

      <hr/>
    </template>

    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Nhập tên</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.nameSelected" :options="nameList"
                         placeholder="-- Nhập tự do (Tagging)" label="name" track-by="id"
                         :multiple="true" :taggable="true" @tag="addTag"></vue-multiselect>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import {filterSidebarList} from '@/mixins/other/filter'

export default {
  name: "FilterPanel",
  mixins: [
    filterSidebarList
  ],
  components: {
    VueMultiselect
  },
  props: {
    pathName: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
